var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"station"},[_c('div',{staticClass:"media-screen timehop-screen"},[_c('Three60Environment',{attrs:{"panos":_vm.panoData,"heading":"Time Hop","copy":""}})],1)]),_c('StationNav',{attrs:{"station":_vm.stationData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }